export const pillars = ['Contentieux', 'Contrats', 'Instruction', 'Intake', 'Recherche', 'Cabinet'];
export const volumes = [{
  n: 1,
  emoji: '📘',
  title: "L'Architecte du Contentieux (Le Plan de Rédaction)",
  desc: 'Générez des récits parfaits pour vos conclusions, assignations et requêtes. Libérez votre agenda et gagnez vos dossiers en quelques minutes.'
}, {
  n: 2,
  emoji: '📔',
  title: 'Intelligence Contractuelle (La Logique Transactionnelle)',
  desc: "Maîtrisez l'analyse médico-légale pour la détection des risques, les clauses d'indemnisation et l'atténuation des risques. Ne doutez plus jamais de votre logique contractuelle."
}, {
  n: 3,
  emoji: '📕',
  title: "Moteur d'Instruction (Le Bouclier de la Preuve)",
  desc: "Un cadre organisé pour les résumés d'auditions, la cartographie des pièces et les interrogatoires. Construit pour survivre à l'examen le plus strict."
}, {
  n: 4,
  emoji: '📓',
  title: 'Intake & Recherche (Le Moteur Pré-Procès)',
  desc: 'Dominez le filtrage des clients, la recherche statutaire et les synthèses de jurisprudence. Transformez les données brutes en stratégie juridique actionnable.'
}, {
  n: 5,
  emoji: '📗',
  title: 'Conseiller Persuasif (La Forteresse de Communication)',
  desc: 'Gérez les mises en demeure, les rapports clients et les explications complexes dans un français clair. Assurez-vous que votre voix est entendue et comprise.'
}, {
  n: 6,
  emoji: '📙',
  title: 'Gestion de Cabinet (Le Commandement de la Pratique)',
  desc: 'Logique de facturation interne, suivi des performances et flux de travail administratifs. Optimisez chaque tâche de bureau qui vous éloigne du travail facturable.'
}];
export const volumeIncludes = ['Prompts « Copier-Coller » étape par étape', 'Crochets à remplir pour une personnalisation rapide', 'Alignement sur la terminologie juridique française', 'Checklists de vérification « Prêt pour le Tribunal »'];
export const bonuses = [{
  n: '01',
  title: 'Le Protocole Zéro-Erreur™',
  desc: "Automatisez votre processus de vérification pour garantir qu'aucune hallucination d'IA n'atteigne votre version finale.",
  price: '32 €',
  cover: 'https://cdn.magicpatterns.com/uploads/pV55c1D1XJdgqzf3mRto3m/ChatGPT_Image_30_sept_2026,_15_09_16.webp'
}, {
  n: '02',
  title: 'Configuration « Maître Partner »™',
  desc: "Configurez votre IA pour qu'elle agisse comme un Associé Senior spécialisé dans votre domaine spécifique.",
  price: '30 €',
  cover: 'https://cdn.magicpatterns.com/uploads/qtBtLZLNM281WhwXfVU269/ChatGPT_Image_30_sept_2026,_15_09_16_(1).webp'
}, {
  n: '03',
  title: 'Le Framework Rainmaker™',
  desc: "Développez votre cabinet grâce à des stratégies de marketing et d'acquisition de clients pilotées par l'IA en quelques secondes.",
  price: '27 €',
  cover: 'https://cdn.magicpatterns.com/uploads/gyHJzWs4nBPSJMuNETuoCy/ChatGPT_Image_30_sept_2026,_15_09_16_(2).webp'
}, {
  n: '04',
  title: 'La Pratique Sécurisée (Guide Éthique)™',
  desc: "Checklist d'audit instantanée pour garantir que votre usage de l'IA respecte la déontologie et la confidentialité.",
  price: '22 €',
  cover: 'https://cdn.magicpatterns.com/uploads/7xf6eZAHiPu9RphagebVdD/ChatGPT_Image_30_sept_2026,_15_09_16_(3).webp'
}];
